export default "__VITE_ASSET__B741xy_c__"